document.addEventListener('DOMContentLoaded', () => {

  // Get all "navbar-burger" elements
  const $navbarBurgers = Array.prototype.slice.call(document.querySelectorAll('.navbar-burger'), 0);

  // Check if there are any navbar burgers
  if ($navbarBurgers.length > 0) {

    // Add a click event on each of them
    $navbarBurgers.forEach( el => {
      el.addEventListener('click', () => {

        // Get the target from the "data-target" attribute
        const target = el.dataset.target;
        const $target = document.getElementById(target);

        // Toggle the "is-active" class on both the "navbar-burger" and the "navbar-menu"
        el.classList.toggle('is-active');
        $target.classList.toggle('is-active');

      });
    });
  }

});

  // Stycky Header
  window.onload = function() {stickyHeader()};
  // window.onscroll = function() {stickyHeader()}; no needed?
  window.addEventListener('scroll', stickyHeader);
  window.addEventListener('resize', stickyHeader);


  // Get the header
  var body = document.body;
  var header = document.getElementById('site-header');
  var headerHeight = header.offsetHeight;

  // Get the offset position of the navbar
  var sticky = header.offsetTop;

  // Add the sticky class to the header when you reach its scroll position. Remove "sticky" when you leave the scroll position
  function stickyHeader() {
    if (document.getElementById('site-header').classList.contains("is-sticky")) {
      document.body.classList.add("is-sticky");
      body.style.padding = headerHeight + "px 0 0 0";
    }
    
    
    if (window.pageYOffset > sticky) {
      header.classList.add("is-on");
    } else {
      header.classList.remove("is-on");
    }
    
  }